export default __webpack_public_path__ + "static/media/card-jcb.df01b73a.svg";